import React from "react";
import { gql } from "@apollo/client";
import { FormattedDate } from "react-intl";
import { Link } from "react-router-dom";

import { List, ListItem, ListItemText, Tooltip } from "@mui/material";
import {
  Sync as OtherCommandsIcon,
  CurrencyUsd as PaymentIcon,
  CurrencyUsdOff as NoPaymentIcon,
} from "mdi-material-ui";

import SidebarItem from "./SidebarItem";

export default function OrderSidebarOtherOrders({ order }) {
  const ordersEdges = order.user.orders.edges.filter(
    ({ node }) => node.id !== order.id
  );

  if (ordersEdges.length === 0) return null;

  return (
    <SidebarItem icon={<OtherCommandsIcon />} title="Autres commandes">
      <List disablePadding>
        {ordersEdges.map(({ cursor, node }) => (
          <ListItem
            key={cursor}
            button
            dense
            component={Link}
            to={`/orders/${node.id}`}
          >
            <ListItemText
              primary={
                <FormattedDate
                  value={node.createdAt}
                  year="numeric"
                  month="long"
                  day="2-digit"
                  hour="2-digit"
                  minute="2-digit"
                />
              }
            />

            {!!node.paymentId ? (
              <Tooltip
                placement="right"
                title={
                  <>
                    Payé le{" "}
                    <FormattedDate
                      value={node.paymentDate}
                      year="numeric"
                      month="long"
                      day="2-digit"
                      hour="2-digit"
                      minute="2-digit"
                    />
                  </>
                }
              >
                <PaymentIcon sx={{ color: (t) => t.palette.success.main }} />
              </Tooltip>
            ) : (
              <Tooltip placement="right" title="Commande non réglée">
                <NoPaymentIcon sx={{ color: (t) => t.palette.error.main }} />
              </Tooltip>
            )}
          </ListItem>
        ))}
      </List>
    </SidebarItem>
  );
}

OrderSidebarOtherOrders.fragments = {
  order: gql`
    fragment Orders_OrderSidebarOtherOrders_Order on Order {
      id

      user {
        id
        orders {
          edges {
            cursor
            node {
              id
              createdAt
              paymentId
              paymentDate
            }
          }
        }
      }
    }
  `,
};
